var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeOrderDeliverd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 48,
    viewBox: "0 0 215 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09766 32.1086C2.09766 32.1086 10.4281 31.033 19.8994 33.6169C37.9131 38.5315 38.9407 29.5318 45.6204 25.1923C51.7316 21.2222 56.7928 23.6445 63.5971 28.4997C68.6156 32.0805 75.9294 38.0915 83.5037 37.1238C90.4273 36.2392 95.3356 29.1892 104.933 27.3963C112.539 25.9753 118.72 29.8792 127.479 28.4997C139.36 26.6282 144.668 15.6107 153.159 15.6107C163.64 15.6107 171.019 6.29248 180.554 6.29248C190.032 6.29248 191.319 11.7718 201.687 15.6107C209.614 18.5456 213.428 15.6107 213.428 15.6107V47.0598H2.09766V32.1086Z",
    fill: "url(#paint0_linear_8654_9906)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09766 27.2239C2.09766 27.2239 10.4281 26.1638 19.8994 28.7104C37.9131 33.5538 38.9407 24.6844 45.6204 20.4077C51.7316 16.4951 56.7928 18.8823 63.5971 23.6672C68.6156 27.1963 75.9294 33.1202 83.5037 32.1665C90.4273 31.2947 95.3356 24.3468 104.933 22.5798C112.539 21.1794 118.72 25.0268 127.479 23.6672C139.36 21.8228 144.668 10.9648 153.159 10.9648C163.64 10.9648 171.019 1.75928 180.554 1.75928C190.032 1.75928 190.536 7.18149 200.904 10.9648C208.831 13.8572 213.428 10.9648 213.428 10.9648",
    stroke: "#F81BF8",
    strokeWidth: 2.71268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8654_9906",
    x1: 40.2904,
    y1: 26.978,
    x2: 40.2904,
    y2: 47.0598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOrderDeliverd);
export default __webpack_public_path__ + "static/media/home-order-deliverd.4481eeaf55f1f34c4dffe5890099a6d7.svg";
export { ForwardRef as ReactComponent };